import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { hexToRgba } from "helpers/cssColors";

export const ToastProviderStyle = {
  ToastProvider: styled.div`
    .p-toast-message {
      box-shadow: ${styleTokens.toast.success.shadow};
    }
    .p-toast .p-toast-message-content {
      align-items: flex-start;
    }
    .p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon {
      color: ${styleTokens.message.info.color};
    }
    .p-toast-message.p-toast-message-info {
      border: none;
      background-color: ${styleTokens.message.info.background};
      color: ${styleTokens.message.info.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.info.color};
      }
    }
    .p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon {
      color: ${styleTokens.message.error.color};
    }
    .p-toast-message.p-toast-message-error {
      border: none;
      background-color: ${styleTokens.message.error.background};
      color: ${styleTokens.message.error.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.error.color};
      }
    }
    .p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon {
      color: ${styleTokens.message.warn.color};
    }
    .p-toast-message.p-toast-message-warn {
      border: none;
      background-color: ${styleTokens.message.warn.background};
      color: ${styleTokens.message.warn.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.warn.color};
      }
    }

    .p-toast .p-toast-message.p-toast-message.p-toast-message-success .p-toast-message-icon {
      color: ${styleTokens.message.success.color};
    }
    .p-toast-message.p-toast-message-success {
      border: none;
      background-color: ${styleTokens.message.success.background};
      color: ${styleTokens.message.success.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.success.color};
      }
    }

    // AI TOAST STYLES
    .p-toast-message.p-toast-message-ai {
      border-radius: 4px;
      border: 1px solid ${styleTokens["Ideally-Core"].candy[70]};
      background-color: ${styleTokens.card.background};
      color: ${styleTokens.Surface.Text.main};
    }

    .p-toast-message.p-toast-message-ai:not(.init) {
      animation:
        glow 1000ms ease-in-out 200ms forwards,
        holdGlow 300ms linear 900ms forwards,
        reduceGlow 500ms ease-in-out 2000ms forwards;
    }

    @keyframes glow {
      0% {
        box-shadow: 0 0 8px 5px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.25)};
      }
      100% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
    }

    @keyframes holdGlow {
      0% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
      100% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
    }

    @keyframes reduceGlow {
      0% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
      100% {
        box-shadow: 0 0 8px 5px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.25)};
      }
    }
  `,
};
